// extracted by mini-css-extract-plugin
export default {"card":"VerifiedStepCard_card__owKPi","icon":"VerifiedStepCard_icon__TOOov","label":"VerifiedStepCard_label__nvG3B"};